import React, { FC, useEffect, useState } from "react";
import { ReactComponent as NotificationIcon } from "../../common/assats/menu/Notification.svg";
import "./Notification.scss";
import {
  filterNotifications,
  getUserNotifications,
} from "../../common/api/notificationService";
import { NotificationType } from "../../common/types/notificationType";
import { useUser } from "../../common/contexts/UserContext";

interface NotificationProps {
  onClick?: () => void;
}

const Notification: FC<NotificationProps> = ({ onClick }) => {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const { user } = useUser();
  const isAdmin = user?.role === "Admin";

  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        let notifications: NotificationType[] = [];

        if (isAdmin) {
          // Admin: Use `filterNotifications` with default preferences
          notifications = await filterNotifications(true, true, true);
        } else {
          // Non-Admin: Use `getUserNotifications`
          if (user?.id) {
            notifications = await getUserNotifications(user.id);
          }
        }

        // Calculate unread notifications
        const unread = notifications.filter(
          (notification) => notification.read === false
        );
        setUnreadCount(unread.length);
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
        setUnreadCount(0);
      }
    };

    fetchUnreadCount();
  }, [isAdmin, user?.id]);

  return (
    <div className="notification-icon-container">
      <span className="notification-icon" onClick={onClick}>
        <NotificationIcon />
      </span>
      {unreadCount > 0 && (
        <span className="notification-amount">{unreadCount}</span>
      )}
    </div>
  );
};

export default Notification;
